import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-main-sidebar',
    templateUrl: './app-main-sidebar.component.html',
    styleUrls: ['./app-main-sidebar.component.scss'],
    standalone: false
})
export class AppMainSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
